import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import JobSearch from "@sourceflow-uk/job-search";
import { Container, Row, Col } from 'reactstrap';
import styles from './styles.module.scss';
import { motion } from 'framer-motion';
import LogoIcon from "/public/site-assets/svg/logo-icon.svg"

export const MainBanner = ({
    className,
    title,
    content,
    image,
    jobSearch,
}) => {

    const variants_1 = {
        hidden: { opacity: 0.005, y: 40 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.5, delay: 0.05 } },
    };
    const variants_2 = {
        hidden: { opacity: 0.005, y: 40 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.5, delay: 0.2 } },
    };

    return (
        <section className={`${styles.root} ${className} position-relative overflow-hidden`}>
            <span className="position-absolute icon-overlay">
                <LogoIcon />
            </span>
            <Container>
                <Row className="m-0">
                    <Col lg={6} className="contentWrapper d-flex flex-wrap align-items-center position-relative">
                        <div>
                            <motion.div initial="hidden" animate="visible" variants={variants_1}>
                                {title &&
                                    <h1>{title}</h1>
                                }
                                {content &&
                                    <div className="mt-3" dangerouslySetInnerHTML={{ __html: content }} />
                                }
                            </motion.div>
                            {jobSearch &&
                                <motion.div initial="hidden" animate="visible" variants={variants_2}>
                                    <JobSearch
                                        options={{
                                            searchResults: false,
                                            searchFilters: false,
                                            submitDestination: "/jobs",
                                        }}
                                        translations={{
                                            "input.placeHolder": "Job Title or Keyword",
                                        }}
                                    />
                                </motion.div>
                            }
                        </div>
                    </Col>
                    <Col lg={6} className="position-relative mainImageWrapper">
                        <SourceFlowImage
                            src={image?.url ? image?.url : "/site-assets/images/banner.webp"}
                            size="1000x"
                            alt={image?.alt ? image?.alt : title}
                            className="card-img rounded-4"
                        />
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default MainBanner;
